import Vue from 'vue'
import Vuex from 'vuex'
import apiCalls from '@/helpers/apiCall'
import api from '@/helpers/api'

Vue.use(Vuex)

/** Evita vários GET /api/products/bytype/... em paralelo antes do primeiro completar. */
let fetchServicesProductsInFlight = null

const state = {
  allProducts: [],
  servicesProducts: [],
  productsLoaded: false,
  servicesLoaded: false,
  productsLastFetch: null,
  servicesLastFetch: null,
  companyService: null,
  companyServiceLoaded: false,
  companyServiceLastFetch: null
}

const mutations = {
  setAllProducts(state, products) {
    state.allProducts = products
    state.productsLoaded = true
    state.productsLastFetch = Date.now()
  },
  setServicesProducts(state, products) {
    state.servicesProducts = products
    state.servicesLoaded = true
    state.servicesLastFetch = Date.now()
  },
  setCompanyService(state, companyService) {
    state.companyService = companyService
    state.companyServiceLoaded = true
    state.companyServiceLastFetch = Date.now()
  }
}

const actions = {
  async getAllProducts({ commit, state }, forceRefresh = false) {
    // Cache de 60 segundos - produtos mudam raramente
    const CACHE_DURATION = 60000
    const now = Date.now()

    if (
      !forceRefresh &&
      state.productsLoaded &&
      state.productsLastFetch &&
      now - state.productsLastFetch < CACHE_DURATION &&
      Array.isArray(state.allProducts) &&
      state.allProducts.length > 0
    ) {
      return Promise.resolve(state.allProducts)
    }

    return await apiCalls.get(api.ProductsGetAll, '', '').then(res => {
      commit('setAllProducts', res.data)
      return res.data
    })
  },
  async getServicesProducts({ commit, state }, forceRefresh = false) {
    // Uma vez por sessão após login (ou forceRefresh); evita repetir ao navegar entre páginas.
    if (!forceRefresh && state.servicesLoaded && Array.isArray(state.servicesProducts)) {
      return Promise.resolve(state.servicesProducts)
    }

    if (!forceRefresh && fetchServicesProductsInFlight) {
      return fetchServicesProductsInFlight
    }

    const run = async () => {
      const res = await apiCalls.get(api.ProductsGetServices, '', '')
      commit('setServicesProducts', res.data)
      return res.data
    }

    fetchServicesProductsInFlight = run().finally(() => {
      fetchServicesProductsInFlight = null
    })

    return fetchServicesProductsInFlight
  },
  async getCompanyService({ commit, state }, forceRefresh = false) {
    // Cache de 30 segundos - company service pode mudar mais frequentemente
    const CACHE_DURATION = 30000
    const now = Date.now()

    if (
      !forceRefresh &&
      state.companyServiceLoaded &&
      state.companyServiceLastFetch &&
      now - state.companyServiceLastFetch < CACHE_DURATION &&
      state.companyService !== null
    ) {
      return Promise.resolve(state.companyService)
    }

    return await apiCalls.get(api.CompanyService, '', '').then(res => {
      const data = res.data && res.data[0] ? res.data[0] : null
      commit('setCompanyService', data)
      return data
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
